import type { CheckoutConfig } from '#types/config/pages/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  isFeeRefundable: false,
  showTotalBeforeRewards: true,
} satisfies RecursivePartial<CheckoutConfig>
